import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";
import Card from "../components/Card";
import TypewriterText from "../components/TypeWriterText";

const ScrollDownButton = ({ onClick }) => (
  <button className="scroll-button" onClick={onClick}>
    {/* Text is first */}
    <span className="button-text">Know More</span>
    {/* Arrow is second, so it appears below the text in column layout */}
    <span className="arrow-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="7 13 12 18 17 13"></polyline>
        <polyline points="7 6 12 11 17 6"></polyline>
      </svg>
    </span>
  </button>
);

function LandingPage() {
  // 1. Create a ref to attach to the target element (the card-row)
  const targetRef = useRef(null);

  // 2. Function to handle smooth scrolling to the target ref
  const handleScroll = () => {
    targetRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="landing-page">
      <div className="center-box">
        {/* LOGO (Uncomment and correct the path if you are using an image logo) */}
        {/* <img src={BitcoinIlmLogo} alt="Welcome to BitcoinIlm" className="image-logo" /> */}

        {/* If not using an image, you can use a text header instead: */}
        {/* <h1 className="main-header">Bitcoin Ilm</h1> */}

        {/* 1. The existing Mission card (Large white card) */}
        <Card title="Our Mission">
          <p>
            {/* WRAP CONTENT IN TYPEWRITER TEXT */}
            <TypewriterText
              text="Bitcoin Ilm is a non-profit, open-source e-learning platform dedicated to imparting monetary literacy in accordance with the tenets of Islamic faith through a self-paced 100-day curriculum. Its goal is to educate learners about the utility of Bitcoin as sound money while warning them about the dangers of usurious fiat currencies and other cryptocurrencies."
              delay={30} // Slower for the main card
            />
          </p>
        </Card>
        <Link to="/home">
          <button className="page-button">Start Learning</button>
        </Link>
        {/* --- The Know More Scroll Button --- */}
        <ScrollDownButton onClick={handleScroll} />

        {/* The Main CTA button (linking to the root index) */}

        {/* --- Container for the three new cards (Scrolling target) --- */}
        <div className="card-row" ref={targetRef}>
          {/* 2. New Card 1 - Uses the 'card-module' class for dark styling */}
          <Card title="Niyah (The Intention)" className="card-module">
            <p>
              The goal of this course is to empower learners with sufficient
              knowledge to understand and responsibly use Bitcoin in a way that
              steers clear of Riba & Gharar.
            </p>
          </Card>

          {/* 3. New Card 2 - Uses the 'card-module' class for dark styling */}
          <Card title="Faydah (The Benefit)" className="card-module">
            <p>
              This platform is entirely non-profit and open-source. We believe
              in accessible education for all seeking true monetary
              understanding.
            </p>
          </Card>

          {/* 4. New Card 3 - Uses the 'card-module' class for dark styling */}
          <Card title="Manhaj (The Methodology)" className="card-module">
            <p>
              All educational content covering Islamic Laws is strictly backed
              by evidences from the Qur'an and the Sunnah upon the understanding
              of the early Muslims(Salaf)
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
